import type { TUser } from "@monta/utils";
import { type TUtils } from "@monta/utils";
import CartIcon from "../shared/cartIcon/CartIcon";
import styles from "./afterLogin.module.scss";
import Money from "./money/Money";
import NotificationsIcon from "./notificationIcon/NotificationsIcon";
import Profile from "./profile/Profile";

export interface AfterLoginProps {
  loginInfo: TUser;
  cart: TUtils["cart"];
  auth: TUtils["auth"];
}

const AfterLogin = (props: AfterLoginProps) => {
  const { loginInfo, cart, auth } = props;

  return (
    <div className={styles["after-login"]}>
      <div className={styles["after-login__item"]}>
        <CartIcon cart={cart} />
      </div>
      <div className={styles["after-login__item"]}>
        <Money loginInfo={loginInfo} />
      </div>
      <div className={styles["after-login__item"]}>
        <NotificationsIcon />
      </div>
      <div className={styles["after-login__item"]}>
        <Profile auth={auth} />
      </div>
    </div>
  );
};

export default AfterLogin;
